import React from "react";
import {
  TextField,
  Typography,
  Box,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

const BlanketHistoricOtherDetailsSection = ({ control, errors }) => (
  <Box className="grid grid-cols-1 gap-4">
    <Typography variant="h5" className="font-bold mb-4">
      Other Details
    </Typography>
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Controller
          name="effectiveDate"
          control={control}
          defaultValue=""
          rules={{ required: "Effective Date is required" }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Effective Date"
              type="date"
              fullWidth
              required
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true }}}
              error={!!errors.effectiveDate}
              helperText={errors.effectiveDate ? "Effective Date is required" : ""}
            />
          )}
        />
      </Grid>
    </Grid>
  </Box>
);

BlanketHistoricOtherDetailsSection.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

export default BlanketHistoricOtherDetailsSection;
